import { GET_OUT_OF_STOCK, OUT_OF_STOCK_LOADING } from '../actions/types';

const initialState = {
  loading: false,
  products: [],
};

function reducer(state = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case OUT_OF_STOCK_LOADING:
      return { ...state, loading: true };
    case GET_OUT_OF_STOCK:
      return { ...state, loading: false, products: action.payload };
    default:
      return state;
  }
}

export default reducer;
